import { useEffect, useState } from 'react';
import { Button, Input, Modal, Space, Form, Select } from 'antd';
import styled from 'styled-components';
import { useAppDispatch } from '../../methods/redux/hooks';
import { updateSupportedCurrency } from '../../methods/redux/reducers/currency';

interface IEditCurrency {
	currency: any;
}

export const StyledFormItem = styled(Form.Item)`
	.ant-row {
		display: block;
	}
`;

const allowDepositOptions = [
	{
		key: true,
		label: 'True',
	},
	{
		key: false,
		label: 'False',
	},
];

const EditCurrency = ({ currency }: IEditCurrency) => {
	const dispatch = useAppDispatch();

	const [visible, setVisible] = useState(false);
	const [currencyData, setCurrencyData] = useState({
		currencyId: '',
		name: '',
		symbol: '',
		decimalPrecision: '',
		minimumWithdrawalAmount: '',
		coinGeckoId: '',
		switchWalletId: '',
		iconUrl: '',
		currencyForm: '',
		usdValue: '',
		allowDeposit: false,
		currencyTag: '',
		status: '',
		pricePriority: false,
		minDepositAmount: '',
		minDepositAmountInUsd: '',
		minWithdrawalAmountInUsd: '',
		coinmarketcapSlug: '',
		maxDailySwapAmountInUsd: '',
	});

	const handleInput = (e: any) => {
		const { name, value } = e.target;
		setCurrencyData({ ...currencyData, [name]: value });
	};

	useEffect(() => {
		setCurrencyData({ ...currencyData, ...currency, currencyId: currency._id });
	}, [currency]);

	const handleCurrencyUpdate = async () => {
		await dispatch(updateSupportedCurrency({ ...currencyData }));
		setVisible(false);
	};

	return (
		<div>
			<Button onClick={() => setVisible(true)}>Edit</Button>

			<Modal
				okText="Save Update"
				onOk={handleCurrencyUpdate}
				visible={visible}
				onCancel={() => setVisible(false)}
				title="Edit Currency"
			>
				<Space direction="vertical" size={10} style={{ width: '100%' }}>
					<div>
						<p>Name</p>
						<Input
							name="name"
							value={currencyData.name}
							onChange={handleInput}
							size="large"
							placeholder="Name"
						/>
					</div>
					<div>
						<p>Symbol</p>
						<Input
							name="symbol"
							readOnly
							value={currencyData.symbol}
							size="large"
							placeholder="Symbol"
						/>
					</div>

					<div>
						<p>Usd Value</p>
						<Input
							name="usdValue"
							value={currencyData.usdValue}
							size="large"
							placeholder="Usd Value"
							onChange={handleInput}
						/>
					</div>

					<div style={{ width: '100%' }}>
						<p>Allow Deposit</p>
						<Select
							defaultValue={currencyData.allowDeposit}
							style={{ width: '100%' }}
							onChange={(value) =>
								setCurrencyData({ ...currencyData, allowDeposit: value })
							}
						>
							{allowDepositOptions.map((i: any) => (
								<Select.Option key={i.label} value={i.key}>
									{i.label}
								</Select.Option>
							))}
						</Select>
					</div>

					<div style={{ width: '100%' }}>
						<p>Update Price from Agregators?</p>
						<Select
							defaultValue={currencyData.pricePriority}
							style={{ width: '100%' }}
							onChange={(value) =>
								setCurrencyData({ ...currencyData, pricePriority: value })
							}
						>
							{allowDepositOptions.map((i: any) => (
								<Select.Option key={i.label} value={i.key}>
									{i.label}
								</Select.Option>
							))}
						</Select>
					</div>

					<div>
						<p>Decimal Precision</p>
						<p>
							Decimal precision used in the app (not the crypto currency
							decimals from the token smart contract)
						</p>
						<Input
							name="decimalPrecision"
							value={currencyData.decimalPrecision}
							onChange={handleInput}
							size="large"
							placeholder="Decimal Precision"
						/>
					</div>
					<div>
						<p>
							Minimum Withdrawal Amount (This is auto set from the USD amount)
						</p>
						<Input
							name="minimumWithdrawalAmount"
							value={currencyData.minimumWithdrawalAmount}
							onChange={handleInput}
							size="large"
							placeholder="Minimum Withdrawal Amount"
							disabled
						/>
					</div>

					<div>
						<p>Max Daily Swap Amount (This is auto set from the USD amount)</p>
						<Input
							name="maxDailySwapAmountInUsd"
							value={currencyData.maxDailySwapAmountInUsd}
							onChange={handleInput}
							size="large"
							placeholder="Max Daily Swap Amount"
						/>
					</div>

					<div>
						<p>Coin Market Cap Slug</p>
						<Input
							name="coinmarketcapSlug"
							value={currencyData.coinmarketcapSlug}
							onChange={handleInput}
							size="large"
							placeholder="Enter Coin market Cap Slug"
						/>
					</div>
					<div>
						<p>Minimum Withdrawal Amount (Usd)</p>
						<Input
							name="minWithdrawalAmountInUsd"
							value={currencyData.minWithdrawalAmountInUsd}
							onChange={handleInput}
							size="large"
							placeholder="Minimum Withdrawal Amount in Usd"
						/>
					</div>
					<div>
						<p>Minimum Deposit Amount (This is auto set from the USD amount)</p>
						<Input
							name="minDepositAmount"
							value={currencyData.minDepositAmount}
							onChange={handleInput}
							size="large"
							placeholder="Minimum Deposit Amount"
							disabled
						/>
					</div>
					<div>
						<p>Minimum Deposit Amount (Usd)</p>
						<Input
							name="minDepositAmountInUsd"
							value={currencyData.minDepositAmountInUsd}
							onChange={handleInput}
							size="large"
							placeholder="Minimum Deposit Amount in Usd"
						/>
					</div>
					<div>
						<p>Currency Tag</p>
						<Input
							name="currencyTag"
							value={currencyData.currencyTag}
							onChange={handleInput}
							size="large"
							placeholder="Currency Tag"
						/>
					</div>
					<div style={{ width: '100%' }}>
						<p>Status</p>
						<Select
							defaultValue={currencyData.status}
							style={{ width: '100%' }}
							onChange={(value) =>
								setCurrencyData({ ...currencyData, status: value })
							}
						>
							<Select.Option value="active">Active</Select.Option>
							<Select.Option value="deleted">Deleted</Select.Option>
						</Select>
					</div>
					{currencyData.currencyForm === 'crypto' && (
						<div>
							<p>Switch Wallet Id</p>
							<Input
								name="switchWalletId"
								value={currencyData.switchWalletId}
								onChange={handleInput}
								size="large"
								placeholder="Switch Wallet Id"
							/>
						</div>
					)}
					{currencyData.currencyForm === 'crypto' && (
						<div>
							<p>CoinGecko Id</p>
							<Input
								name="coinGeckoId"
								value={currencyData.coinGeckoId}
								onChange={handleInput}
								size="large"
								placeholder="Coin Gecko Id"
							/>
						</div>
					)}
					<div>
						<p>Logo URL</p>
						<Input
							name="iconUrl"
							value={currencyData.iconUrl}
							onChange={handleInput}
							size="large"
							placeholder="Logo Url"
						/>
					</div>
					<div>
						<p>
							<strong>View Logo</strong>
						</p>
						<img
							src={currencyData.iconUrl}
							alt=""
							className="logo"
							style={{
								width: 50,
								height: 50,
							}}
						/>
					</div>
				</Space>
			</Modal>
		</div>
	);
};

export default EditCurrency;
